const API_BASE = '/api/actions';

export const getActionFeed = async (authenticatedFetch, params = {}) => {
  const query = new URLSearchParams();
  if (params.severity) query.set('severity', params.severity);
  if (params.client_id) query.set('client_id', params.client_id);
  if (params.action_type) query.set('action_type', params.action_type);

  const url = query.toString() ? `${API_BASE}?${query}` : API_BASE;
  const response = await authenticatedFetch(url);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to fetch action feed', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to fetch action feed');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const generateActions = async (authenticatedFetch) => {
  const response = await authenticatedFetch(`${API_BASE}/generate`, {
    method: 'POST',
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to generate actions', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to generate actions');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const resolveAction = async (authenticatedFetch, actionId) => {
  const response = await authenticatedFetch(`${API_BASE}/${actionId}/resolve`, {
    method: 'POST',
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to resolve action', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to resolve action');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const bulkResolveActions = async (authenticatedFetch, actionIds) => {
  const response = await authenticatedFetch(`${API_BASE}/bulk-resolve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action_ids: actionIds }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to bulk resolve actions', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to bulk resolve actions');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};
